import type { Bicycle, ProductVehicle } from '../types';

const motorcycleSorter = (a: ProductVehicle, b: ProductVehicle): number =>
    Number(a.manufacturerName.trim() === '') -
        Number(b.manufacturerName.trim() === '') ||
    Number(a.model.trim() === '') - Number(b.model.trim() === '') ||
    a.manufacturerName.localeCompare(b.manufacturerName) ||
    a.ccm - b.ccm ||
    a.model.localeCompare(b.model) ||
    a.manufacturingStartYear - b.manufacturingStartYear;

export const bicycleSorter = (a: Bicycle, b: Bicycle): number =>
    Number(a.manufacturerName.trim() === '') -
        Number(b.manufacturerName.trim() === '') ||
    Number(a.model.trim() === '') - Number(b.model.trim() === '') ||
    a.manufacturerName.localeCompare(b.manufacturerName) ||
    a.model.localeCompare(b.model) ||
    (a.manufacturingStartYear ?? 0) - (b.manufacturingStartYear ?? 0);

export default motorcycleSorter;
